import { Box, CircularProgress, Typography, Backdrop } from '@mui/material'

export interface LoadingSpinnerProps {
  size?: number | 'small' | 'medium' | 'large'
  message?: string
  overlay?: boolean
  fullScreen?: boolean
}

const LoadingSpinner = ({ 
  size = 'medium', 
  message, 
  overlay = false, 
  fullScreen = false 
}: LoadingSpinnerProps) => {
  const getSize = () => {
    if (typeof size === 'number') return size
    switch (size) {
      case 'small':
        return 24
      case 'medium':
        return 40
      case 'large':
        return 56
      default:
        return 40
    }
  }

  const spinner = (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
      p={4}
    >
      <CircularProgress size={getSize()} />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  )

  if (overlay) {
    return (
      <Backdrop
        open={true}
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        {spinner}
      </Backdrop>
    )
  }

  if (fullScreen) {
    return (
      <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor="rgba(255, 255, 255, 0.8)"
        zIndex={9999}
      >
        {spinner}
      </Box>
    )
  }

  return spinner
}

export default LoadingSpinner
